export default "__VITE_ASSET__de803168__"